import { ElementRef, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
declare var bootstrap: any;

@Injectable({ providedIn: 'root' })
export class DialogService {

    currentModal?: any; 

    public message: string = '';
    public title: string = 'Confirmation';
    public buttons: string[] = ['Yes', 'No', 'Cancel'];

    /** Резолвер для Ask-диалогов */
    private resolveCallback?: (value?: boolean) => void;

    /** Резолвер для кастомного диалога */
    //private modalResultCallback?: (value?: any) => void;

    async info(message: string, title?: string, button?: string): Promise<void> {
        await this.show(message, title || 'Information', [button || 'OK']);
    }

    async confirmation(message: string, title?: string, useCancel?: boolean): Promise<boolean | undefined> {
        return await this.show(message, title || 'Confirmation', useCancel ? ['Yes', 'No', 'Cancel'] : ['Yes', 'No']);
    }

    show(message: string, title?: string, buttons?: string[]): Promise<boolean | undefined> {
        this.message = message;
        this.title = title || this.title;
        if (buttons && buttons.length > 0) this.buttons = buttons;
        // открываем через DOM
        const modal = document.getElementById('global_confirmModal');
        (window as any).bootstrap.Modal.getOrCreateInstance(modal).show();

        return new Promise(resolve => this.resolveCallback = resolve);
    }

    open(modal: ElementRef<HTMLElement> | HTMLElement | string): Promise<any> {

        const modalEl: HTMLElement = typeof modal === 'string'
            ? document.getElementById(modal)
            : (modal as any).nativeElement ? (modal as any).nativeElement : modal;

        const priorModal = this.currentModal;
        const modalInstance = (window as any).bootstrap.Modal.getOrCreateInstance(modalEl);
        modalInstance['__priorModal__'] || (modalInstance['priorModal'] = priorModal);
        this.currentModal = modalInstance;

        // одноразовый обработчик закрытия
        const onHidden = (button: any) => {
            modalEl.removeEventListener('hidden.bs.modal', onHidden);
            this.resolveCallback && this.resolveCallback();

            modalInstance['__modalResultCallback__'] && modalInstance['__modalResultCallback__']();
            modalInstance['__modalResultCallback__'] = undefined;
            this.currentModal = modalInstance['__priorModal__'];
        };
        modalEl!.addEventListener('hidden.bs.modal', onHidden);

        modalInstance.show();

        return new Promise(resolve => this.currentModal['__modalResultCallback__'] = <any>resolve);
    }


    answer(result?: boolean) {
        const modal = document.getElementById('global_confirmModal');
        (window as any).bootstrap.Modal.getOrCreateInstance(modal).hide();
        this.resolveCallback && this.resolveCallback(result);
    }

    closeModal(modal?: string | HTMLElement): void {
        let modalElement: HTMLElement | null;

        if (typeof modal === 'string') {
            modalElement = document.getElementById(modal);
        } else if (modal instanceof HTMLElement) {
            modalElement = modal;
        } else {
            modalElement = document.querySelector('.modal.show') as HTMLElement | null;
        }

        if (!modalElement) {
            return;
        }

        const modalInstance = bootstrap.Modal.getInstance(modalElement) ?? bootstrap.Modal.getOrCreateInstance(modalElement);
        modalInstance.hide();
    }

    /** Закрытие последнего открытого модального окна */
    close(result?: any): void {
        if (this.currentModal) {
            const resultCallback = this.currentModal['__modalResultCallback__'];
            this.currentModal['__modalResultCallback__'] = undefined;
            this.currentModal.hide();
            if (resultCallback) {
                resultCallback(result);
            }
        }
    }
}
